// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AppRouteImport } from './routes/_app'
import { Route as CertificadoCodigoRouteImport } from './routes/certificado.$codigo'
import { Route as AuthRegisterRouteImport } from './routes/_auth/register'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppRankingRouteImport } from './routes/_app/ranking'
import { Route as AppMinhaContaRouteImport } from './routes/_app/minha-conta'
import { Route as AppComunidadeRouteImport } from './routes/_app/comunidade'
import { Route as AppCatalogoRouteImport } from './routes/_app/catalogo'
import { Route as AppMenuRouteImport } from './routes/_app/$menu'
import { Route as AppComunidadeIndexRouteImport } from './routes/_app/comunidade.index'
import { Route as AppComunidadeChannelRouteImport } from './routes/_app/comunidade.$channel'
import { Route as AppMenuIndexRouteImport } from './routes/_app/$menu.index'
import { Route as AppMenuProgramaRouteImport } from './routes/_app/$menu.$programa'
import { Route as AppMenuProgramaIndexRouteImport } from './routes/_app/$menu.$programa.index'
import { Route as AppMenuProgramaEpisodioRouteImport } from './routes/_app/$menu.$programa.$episodio'

const AuthRoute = AuthRouteImport.update({
            id: '/_auth',getParentRoute: () => rootRouteImport
          })
const AppRoute = AppRouteImport.update({
            id: '/_app',getParentRoute: () => rootRouteImport
          })
const CertificadoCodigoRoute = CertificadoCodigoRouteImport.update({
            id: '/certificado/$codigo',path: '/certificado/$codigo',getParentRoute: () => rootRouteImport
          })
const AuthRegisterRoute = AuthRegisterRouteImport.update({
            id: '/register',path: '/register',getParentRoute: () => AuthRoute
          })
const AuthLoginRoute = AuthLoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => AuthRoute
          })
const AppIndexRoute = AppIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppRoute
          })
const AppRankingRoute = AppRankingRouteImport.update({
            id: '/ranking',path: '/ranking',getParentRoute: () => AppRoute
          })
const AppMinhaContaRoute = AppMinhaContaRouteImport.update({
            id: '/minha-conta',path: '/minha-conta',getParentRoute: () => AppRoute
          })
const AppComunidadeRoute = AppComunidadeRouteImport.update({
            id: '/comunidade',path: '/comunidade',getParentRoute: () => AppRoute
          })
const AppCatalogoRoute = AppCatalogoRouteImport.update({
            id: '/catalogo',path: '/catalogo',getParentRoute: () => AppRoute
          })
const AppMenuRoute = AppMenuRouteImport.update({
            id: '/$menu',path: '/$menu',getParentRoute: () => AppRoute
          })
const AppComunidadeIndexRoute = AppComunidadeIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppComunidadeRoute
          })
const AppComunidadeChannelRoute = AppComunidadeChannelRouteImport.update({
            id: '/$channel',path: '/$channel',getParentRoute: () => AppComunidadeRoute
          })
const AppMenuIndexRoute = AppMenuIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppMenuRoute
          })
const AppMenuProgramaRoute = AppMenuProgramaRouteImport.update({
            id: '/$programa',path: '/$programa',getParentRoute: () => AppMenuRoute
          })
const AppMenuProgramaIndexRoute = AppMenuProgramaIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppMenuProgramaRoute
          })
const AppMenuProgramaEpisodioRoute = AppMenuProgramaEpisodioRouteImport.update({
            id: '/$episodio',path: '/$episodio',getParentRoute: () => AppMenuProgramaRoute
          })





const AppMenuProgramaRouteChildren = {
  AppMenuProgramaEpisodioRoute: AppMenuProgramaEpisodioRoute,AppMenuProgramaIndexRoute: AppMenuProgramaIndexRoute
}

const AppMenuProgramaRouteWithChildren = AppMenuProgramaRoute._addFileChildren(AppMenuProgramaRouteChildren)



const AppMenuRouteChildren = {
  AppMenuProgramaRoute: AppMenuProgramaRouteWithChildren,AppMenuIndexRoute: AppMenuIndexRoute
}

const AppMenuRouteWithChildren = AppMenuRoute._addFileChildren(AppMenuRouteChildren)




const AppComunidadeRouteChildren = {
  AppComunidadeChannelRoute: AppComunidadeChannelRoute,AppComunidadeIndexRoute: AppComunidadeIndexRoute
}

const AppComunidadeRouteWithChildren = AppComunidadeRoute._addFileChildren(AppComunidadeRouteChildren)



const AppRouteChildren = {
  AppMenuRoute: AppMenuRouteWithChildren,AppCatalogoRoute: AppCatalogoRoute,AppComunidadeRoute: AppComunidadeRouteWithChildren,AppMinhaContaRoute: AppMinhaContaRoute,AppRankingRoute: AppRankingRoute,AppIndexRoute: AppIndexRoute
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)




const AuthRouteChildren = {
  AuthLoginRoute: AuthLoginRoute,AuthRegisterRoute: AuthRegisterRoute
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren = {
  AppRoute: AppRouteWithChildren,AuthRoute: AuthRouteWithChildren,CertificadoCodigoRoute: CertificadoCodigoRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)